export class TimeFrameForm {
    constructor(repeatDuration: string, repeatInterval: number, startDate: Date, endDate? : Date, repeatDayOfWeek? : number) {
        this.repeatDuration = repeatDuration;
        this.repeatInterval = repeatInterval;
        this.startDate = startDate;
        this.endDate = endDate;
        this.repeatDayOfWeek = repeatDayOfWeek;
        if (!this.repeatDayOfWeek) this.repeatDayOfWeek = 1;
        this.valid = true;
        this.repeatDayOfMonth = 1;
        this.repeatWeekOfMonth = 1;
        this.monthRepeatType = 0; // 0 for byday (need to make enums for these)
    }
    
    id? : number;
    repeatDuration: string;
    repeatInterval: number;
    startDate: Date;
    endDate: Date;
    valid: boolean;
    repeatDayOfWeek: number;
    repeatDayOfMonth: number;
    repeatWeekOfMonth: number;
    monthRepeatType = 0;
}